import React from "react";
import { Props } from "./interfaces";
import { Container, FirstElementContainer, SecondElementContainer } from "./styles";

const ConcatenatedCell = ({ aligned = "center", FirstElement, SecondElement }: Props) => {
  return (
    <Container aligned={aligned}>
      <FirstElementContainer>{FirstElement}</FirstElementContainer>
      <SecondElementContainer>{SecondElement}</SecondElementContainer>
    </Container>
  );
};

export default ConcatenatedCell;
